import { requireStoreModule } from "$/lib/require-store-module"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/companies")({
  loader: async ({ context: { queryClient } }) => {
    await requireStoreModule(queryClient, "companiesEnabled")
    return {
      crumbs: "alfred.settings.companies.crumb",
    }
  },
})
